import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      getterSession: 'auth/session',
      getterIsLaunch: 'application/isLaunch',
    }),
    mixinsIpGetErrorMessage() {
      return 'Le format de la saisie n\'est pas conforme à une adresse IP. Les clés privées ne sont pas permises';
    },
  },
  mounted() {
  },
  watch: {
    ip() {
      if (this.ip === '') {
        this.errors = false;
      } else {
        this.ip = this.ip.trim();
        this.mixinsIpsIsValidIpv4(this.ip);
      }
      if (this.getterIsLaunch) { this.clearResult(); }
    },
  },
  methods: {
    ...mapActions({
      storePushLogs: 'logs/pushLogsInResult',
      storeResetChangeRoute: 'application/resetChangeRoute',
      storeStartLoading: 'application/startLoading',
      storeStartSearch: 'application/startSearch',
      storeResetSearch: 'application/resetSearch',
      storeFinishLoading: 'application/finishLoading',
    }),
    mixinsIpsIsValidIpv4(value) {
      const ipv4 = value.split('.');
      if (ipv4.length === 4 && ipv4.every(number => (Number.isInteger(parseInt(number, 10))))) {
        // check private IP
        if (ipv4[0] === '10') {
          this.errors = true;
        } else if (ipv4[0] === '172' && (ipv4[1] >= '16' && ipv4[1] <= '31')) {
          this.errors = true;
        } else if (ipv4[0] === '192' && ipv4[1] === '168') {
          this.errors = true;
        } else {
          this.errors = !ipv4.every(part => (part >= 0 && part <= 255));
        }
      } else {
        this.errors = true;
      }
    },
  },
};
